import { Component, AfterViewChecked } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { DataService } from '../shared/services/data.service';
import { AuthorizationService } from './authoriation.service';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
})
export class AuthorizationComponent implements AfterViewChecked {
  private initialized = false;
  constructor(
    private oauthService: OAuthService,
    private authorizationService: AuthorizationService,
    private router: Router,
    private _commonService: DataService,
  ) {}


  ngAfterViewChecked() {
    if (this.initialized) {
      return;
    }

    if (this.oauthService.hasValidAccessToken()) {
      const isFromWBQuote = localStorage.getItem('IsFromWBQuote');
      const isDirectUser = localStorage.getItem('IsDirectUser');

      if (isDirectUser === 'Yes' && !isFromWBQuote) {
        this.FetchBrokerAccounts(this.authorizationService.userId);
        this.initialized = true;
        return;
      }

      const impersonateUserId = localStorage.getItem('impersonateUserId');
      if (impersonateUserId) {
        const id = parseInt(impersonateUserId, 10);
        if (!Number.isNaN(id)) {
          this.FetchBrokerAccounts(id);
          this.initialized = true;
          return;
        }
      }

      this.router.navigateByUrl('/group/0');
      this.initialized = true;
    }
  }
  private FetchBrokerAccounts(userId: number) {
    this._commonService.getUserInformation(userId).subscribe(result => {
        if (result != null && result != undefined && typeof (result) == "object" && result.Brokers != null && result.Brokers.length > 0) {
          localStorage.removeItem('group_id');
          let userInformation = result;
          let brokerState=this._commonService.getBrokerLicensedStates(userInformation.Brokers)
          let brokerAccount = result.Brokers.find((broker: { BrokerId: number; }) => broker.BrokerId == Number(localStorage.getItem("broker_id")));
          if(brokerAccount == undefined) {
            brokerAccount = result.Brokers[0];
          }
          if (brokerAccount != undefined) {
            localStorage.setItem("broker_id", brokerAccount.BrokerId);
            localStorage.setItem("broker_state",brokerAccount.BrokerLicenses[0].StateId);
            localStorage.setItem("salesRepName", brokerAccount.SalesRepName);
            localStorage.setItem("salesRepEmail", brokerAccount.SalesRepEmail);
            localStorage.setItem("broker_name", brokerAccount.FirstName + " " + brokerAccount.LastName);
            localStorage.setItem("broker_LicenseNumber", brokerAccount.BrokerLicenses[0].LicenseNumber);
            localStorage.setItem("broker_Phone", brokerAccount.Phone);
            localStorage.setItem("email", userInformation.Email);
            localStorage.setItem("broker_tier_description", brokerAccount.BrokerTierDescription);
            localStorage.setItem("broker_licensed_states", brokerState);
            this.router.navigateByUrl('/group/0');
          }
        }
    },  
    (error) => {
        console.error('FetchBrokerAccounts error', error);
      },
    );
  }

}
